import { IsArray, IsDefined, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../base.dto';
import type { PurchaseOrderInvoiceDto } from './purchase-order-invoice.dto';

export class PurchaseOrderInvoiceStatusDto extends BaseDto {
  @IsDefined()
  @IsString()
  name: string;

  @IsOptional()
  @IsArray()
  purchaseOrderInvoiceArr?: PurchaseOrderInvoiceDto[];
}
